import React from "react"
import BaseAdminLite from "./BaseAdminLite"
import {Button, Card, Col, Form, Input, InputNumber, message, Row, Select, Spin, Typography} from "antd"
import {withBreakpoints} from "react-breakpoints"
import moment from 'moment';
import {API, Auth} from "aws-amplify"
import {withRouter} from 'react-router-dom'
import '../../Styles/UserPanel/Invoice.css'
import definitions from "../../Util/AFIPdefinitions"
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"

const {Option} = Select;
const {TextArea} = Input;
const {Text} = Typography;
var interval = null
var count = 0

class PersonalDataForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            formData: {
                razon_social: '',
                cuit: null,
                telefono: null,
                email: null,
                id_impositivo: null,
                domicilio_cliente: null,
                localidad: null,
                provinicia: null,
                active_signup: false,
                code_active: null,
                display_name: null
            }
        };
    }

    componentDidMount() {
        this.setState({loading: true})
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/root/admindashboard/' + user.username,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    console.log(JSON.stringify(response));
                    this.setState({loading: false, formData: response})
                })
                .catch(err => console.log(err))
        });
    }


    updateData(fields, values) {
        const new_data = {...this.state.formData}
        for (var i = 0; i < fields.length; i++) {
            new_data[fields[i]] = values[i]
        }
        this.setState({formData: new_data})
    }



    save = () => {
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.setState({loading: true});
                const body = {...this.state.formData}
                Promise.all([
                    Auth.currentSession(),
                    Auth.currentUserInfo()
                ]).then(([response, user]) => {
                    API.put(
                        'test',
                        '/root/admindashboard/',
                        {
                            headers: {
                                Authorization: response.getIdToken().getJwtToken()
                            },
                            body: body
                        }
                    )
                        .then(response => {
                            this.setState({loading: false, formData: response})
                        })
                        .catch(err => console.log(err))
                });
            }
        });

    }

    render() {
        if (this.state.loading) {
            return (
                <BaseAdminLite selected="personal-data">
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseAdminLite>)
        } else {

            const {getFieldDecorator, getFieldValue, resetFields} = this.props.form;
            const currentStep = 0;
            const steps = [
                {
                    title: 'Datos',
                    content:
                        <>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="CUIT">
                                        {
                                            getFieldDecorator('cuit', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ],
                                                value: this.state.formData.cuit,
                                                initialValue: this.state.formData.cuit,
                                                validateFirst: true
                                            })(
                                                <Input
                                                    disabled={true}
                                                    style={{width: '100%'}}
                                                    onChange={(value) => this.updateData(["cuit"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Razon Social">
                                        {
                                            getFieldDecorator('razon', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ],

                                                value: this.state.formData.razon_social,
                                                initialValue: this.state.formData.razon_social,
                                                validateFirst: true
                                            })(
                                                <Input
                                                    disabled={true}
                                                    style={{width: '100%'}}
                                                    onChange={(value) => this.updateData(["razon_social"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Email">
                                        {
                                            getFieldDecorator('email', {
                                                value: this.state.formData.email,
                                                initialValue: this.state.formData.email,
                                                rules: [
                                                    {
                                                        type: 'email',
                                                        message: 'Email válido requerido',
                                                    },
                                                    {
                                                        required: true,
                                                        message: 'Dato requerido'
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    onChange={(e) => this.updateData(["email"], [e.target.value ? e.target.value : null])}

                                                />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="Condición IVA">
                                        {
                                            getFieldDecorator('id_impositivo', {
                                                rules: [{
                                                    required: true,
                                                }],
                                                value: this.state.formData.id_impositivo,
                                                initialValue: this.state.formData.id_impositivo,
                                            })(
                                                <Select
                                                    disabled={true}
                                                    onChange={(value) => {
                                                        if (value === "consumidor-final") {
                                                            this.updateData(["id_impositivo"], ["consumidor-final"])
                                                        } else {
                                                            this.updateData(["id_impositivo"], [value])
                                                        }
                                                    }}
                                                >
                                                    {
                                                        definitions.responsable.map(value => {
                                                            return (<Option key={value.value}
                                                                            value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>

                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Domicilio">
                                        {
                                            getFieldDecorator('domicilio_cliente', {
                                                value: this.state.formData.domicilio_cliente,
                                                initialValue: this.state.formData.domicilio_cliente,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Domicilio requerido"
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    disabled={true}
                                                    onChange={(e) => this.updateData(["domicilio_cliente"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Localidad">
                                        {
                                            getFieldDecorator('localidad', {
                                                value: this.state.formData.localidad,
                                                initialValue: this.state.formData.localidad,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Dato requerido"
                                                    }
                                                ]
                                            })(
                                                <Input
                                                    disabled={true}
                                                    onChange={(e) => this.updateData(["localidad"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>

                            </Row>
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="Provincia">
                                        {
                                            getFieldDecorator('provincia', {
                                                rules: [{
                                                    required: true,
                                                }],
                                                value: this.state.formData.provincia,
                                                initialValue: this.state.formData.provincia,
                                            })(
                                                <Select
                                                    disabled={true}
                                                    onChange={(value) => {
                                                        this.updateData(["provincia"], value)
                                                    }}
                                                >
                                                    {
                                                        definitions.provincia.map(value => {
                                                            return (<Option key={value.value}
                                                                            value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Telefono">
                                        {
                                            getFieldDecorator('telefono', {
                                                value: this.state.formData.telefono,
                                                initialValue: this.state.formData.telefono
                                            })(
                                                <InputNumber
                                                    style={{width: '100%'}}
                                                    onChange={(e) => this.updateData(["telefono"], [e])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Nombre visible">
                                        {
                                            getFieldDecorator('display_name', {
                                                value: this.state.formData.display_name,
                                                initialValue: this.state.formData.display_name
                                            })(
                                                <Input
                                                    onChange={(e) => this.updateData(["display_name"], [e.target.value ? e.target.value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                }
            ];

            return (
                <BaseAdminLite
                    title="Datos personales"
                    selected='personal-data'
                >
                    <Card
                        style={{marginBottom: 10}}
                    >
                        <Form hideRequiredMark>
                            <div className="steps-content">{steps[currentStep].content}</div>
                        </Form>
                        <div className="steps-action">
                            <Button.Group>
                                <Button type="primary" onClick={() => this.save()} loading={this.state.loading}>
                                    Guardar
                                </Button>

                            </Button.Group>
                        </div>
                    </Card>
                </BaseAdminLite>
            );
        }
    }
}

const PersonalData = Form.create({name: 'invoice'})(withBreakpoints(PersonalDataForm));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PersonalData));
